import { SummaryRow } from '../../../../Summary/SummaryRow';
import { VQ } from '../../../../../store/student/types';
import { IVisaPrepForm } from '../../../../../types';
import { boolToYesNo } from '../../../../../utilities/formatting';
import { isPersonTravellingWith } from '../../../../../utilities/pages';
import { useTranslation } from "react-i18next";

function VisaPrepFamilyStep3(props: IVisaPrepForm) {
    const { t } = useTranslation('forms.visa');
  return (
    <>
      <SummaryRow
        className={'visa-summary'}
        key={VQ.MOTHERS_PERSONAL_DETAILS}
        label={t('forms.visa:doYouHaveYourMotherSPersonalDeta')}
        value={boolToYesNo(props.hasMothersPersonalDetails)}
      />
      {props.hasMothersPersonalDetails === true ? (
        <>
          <SummaryRow
            className={'visa-summary'}
            key={VQ.MOTHER_NATIONALITY}
            value={props.motherNationality}
            label={t('forms.visa:motherSNationality')}
          />
          <SummaryRow
            className={'visa-summary'}
            key={VQ.MOTHER_SAME_NATIONALITY}
            label={t('forms.visa:haveTheyAlwaysHadTheSameNational')}
            value={boolToYesNo(props.motherSameNationality)}
          />
          <SummaryRow
            className={'visa-summary'}
            key={VQ.MOTHER_FAMILY_NAME}
            value={props.motherFamilyName}
            label={t('forms.visa:motherSFamilyName')}
          />
          <SummaryRow
            className={'visa-summary'}
            key={VQ.MOTHER_GIVEN_NAME}
            value={props.motherGivenName}
            label={t('forms.visa:motherSGivenName')}
          />
          <SummaryRow
            className={'visa-summary'}
            key={VQ.MOTHER_DOB}
            label={t('forms.visa:motherSDateOfBirth')}
            value={props.motherDob}
          />
          <SummaryRow
            className={'visa-summary'}
            key={VQ.MOTHER_PLACE_OF_BIRTH}
            value={props.motherPlaceOfBirth}
            label={t('forms.visa:motherSPlaceOfBirth')}
          />
          <SummaryRow
            className={'visa-summary'}
            key={VQ.MOTHER_TRAVELLING_WITH}
            label={t('forms.visa:isThisPersonTravellingWithYou')}
            value={props.motherTravellingWith}
          />
          {isPersonTravellingWith(props.motherTravellingWith) ? (
            <>
              <SummaryRow
                className={'visa-summary'}
                key={VQ.MOTHER_UK_VISA}
                label={t('forms.visa:doTheyHaveAVisaForTheUk')}
                value={props.motherUkVisa}
              />
              <SummaryRow
                className={'visa-summary'}
                key={VQ.MOTHER_HAS_PASSPORT}
                label={t('forms.visa:doTheyHaveAPassportOrTravelDocum')}
                value={boolToYesNo(props.motherHasPassport)}
              />
              {props.motherHasPassport ? (
                <SummaryRow
                  className={'visa-summary'}
                  key={VQ.MOTHER_PASSPORT_NUMBER}
                  value={props.motherPassportNumber}
                  label={t('forms.visa:currentPassportOrTravelDocumentN')}
                />
              ) : null}
            </>
          ) : null}
        </>
      ) : null}
    </>
  );
}

export default VisaPrepFamilyStep3;
